import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import { annualBillInfo } from "@/graphql/star-level.gql";

@Module({ name: "AnnualBillModule", namespaced: true })
export default class AnnualBillModule extends VuexModule<RootState> {
  public detailData: any = {};
  //  查询星级配置
  @Mutation
  saveDetailData(data: any) {
    this.detailData = data || {};
  }
  @Action
  async queryAnnualBillInfo() {
    const data = await queryRequest({
      query: annualBillInfo,
      variables: {}
    });
    this.context.commit("saveDetailData", data);
  }
}
